export default{
    async getTenantList({ commit }, searchParam){
        let sort = {
            key: searchParam.options.sortBy[0],
            asc: !searchParam.options.sortDesc[0]
        }
        let searchData = {
            page: searchParam.options.page,
            per_page: searchParam.options.itemsPerPage,
            sort: sort,
            search: { ...searchParam.searchKeys },
        }
        commit('setSearchingData', searchData, {root: false});
        return await this.$axios.$post(
            this.$api.systemAdmin.stats.getTenantList,
            searchData
        )
    },

    async getCurrentStats({}, tenant_id){
        return await this.$axios.$post(
            this.$api.systemAdmin.stats.getCurrentStats,
            {tenant_id: tenant_id}
        )
    },

    async getDailyUsingCounts({commit}, searchParam){
        let searchData = {
            start_date: searchParam.start_date,
            end_date: searchParam.end_date,
            tenant_id: searchParam.tenant_id
        }
        commit('setTimeRangeDaily', searchData);
        return await this.$axios.$post(
            this.$api.systemAdmin.stats.getDailyUsingCounts,
            searchData
        )
    },

    async getHourlyUsingUserNumber({commit}, searchParam){
        let searchData = {
            start_datetime: searchParam.start_datetime,
            end_datetime: searchParam.end_datetime,
            tenant_id: searchParam.tenant_id
        }
        commit('setTimeRangeHourly', searchData);
        return await this.$axios.$post(
            this.$api.systemAdmin.stats.getHourlyUsingUserNumber,
            searchData
        )
    },

    async changeSelectTenant({ commit }, selectedTenant){
        commit('setSelectTenant', selectedTenant, {root: false});
    },


    async downloadCsvHourlyUsingUserNumber({}, searchParam){
        let searchData = {
            start_datetime: searchParam.start_datetime,
            end_datetime: searchParam.end_datetime,
            tenant_id: searchParam.tenant_id
        }
        return this.$downloader.downloadPost(this.$axios, this.$api.systemAdmin.stats.downloadCsvHourlyUsingUserNumber, searchData)
        .catch(error => {
        });
    },

    async downloadCsvDailyUsingCounts({}, searchParam){
        let searchData = {
            start_date: searchParam.start_date,
            end_date: searchParam.end_date,
            tenant_id: searchParam.tenant_id
        }
        return this.$downloader.downloadPost(this.$axios, this.$api.systemAdmin.stats.downloadCsvDailyUsingCounts, searchData)
        .catch(error => {
        });
    },

    async downloadCsvTenantList({}, searchParam){
        let sort = {
            key: searchParam.options.sortBy[0],
            asc: !searchParam.options.sortDesc[0]
        }
        let searchData = {
            page: searchParam.options.page,
            per_page: searchParam.options.itemsPerPage,
            sort: sort,
            search: { ...searchParam.searchKeys },
        }
        return this.$downloader.downloadPost(this.$axios, this.$api.systemAdmin.stats.downloadCsvTenantList, searchData)
        .catch(error => {
        });
    }
}